import { useEffect, useState, useRef } from "react";
import axios from "axios";

const useFetchProductByName = (productName) => {
  const [product, setproduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const isFetched = useRef(false); // ✅ Prevents duplicate API call
  useEffect(() => {
    if (!isFetched.current && productName) {
      fetchProduct();
      isFetched.current = true; // ✅ Ensure it runs only once
    }
  }, [productName]);
  const fetchProduct = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}api/Products/ByName/${productName}`
      );

      if (response.data) {
        if (
          response.data.listContent &&
          Array.isArray(response.data.listContent)
        ) {
          response.data.listContent.sort((a, b) => a.sortOrder - b.sortOrder);
        }
        if (response.data.images && Array.isArray(response.data.images)) {
          response.data.images.sort((a, b) => a.sortOrder - b.sortOrder);
        }
        setproduct(response.data);
      }
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };
  return { product, loading, error };
};

export default useFetchProductByName;
